import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {VwpTeamMemberLicense} from "../../../../store/generated/api.ts";
import LicenseChip from "../../../shared/selectors/LicenseChip";

interface LicenseDisplayProps {
    licenses: VwpTeamMemberLicense[];
}

export function LicenseDisplay({licenses}: LicenseDisplayProps) {
    const {t} = useTranslationWithKeys();
    return (
        <>
            {licenses && licenses.length > 0 ? (
                <div className="flex flex-wrap gap-1">
                    {licenses.map((license, idx) => (
                        <LicenseChip
                            key={idx}
                            productName={license.name}
                            licenseId={license.id}
                            variant="compact"
                        />
                    ))}
                </div>
            ) : (
                <span className="text-muted-foreground">{t('common.status.none')}</span>
            )}
        </>
    );
}